import { useMutation, type ApolloCache } from '@apollo/client';
import { graphql } from 'gql.tada';

const CopyClassRosterMutation = graphql.persisted(
  "CopyClassRoster",
  graphql(`
    mutation CopyClassRoster($input: CopyClassRosterInput!) {
      copyClassRoster(input: $input) {
        sourceStudentCount
        targetCount
        addedCount
        reactivatedCount
        alreadyActiveCount
        capacitySkippedCount
        ineligibleSkippedCount
        copiedCount
        skippedCount
        gradebookMembershipAddedCount
        gradebookMembershipReactivatedCount
        gradebookMembershipAlreadyActiveCount
        gradebookMembershipCopiedCount
        unmatchedTranscriptCourseCount
        unmatchedGradebookMembershipCount
        targetResults {
          targetClassOfferingId
          targetDisplayName
          addedCount
          reactivatedCount
          alreadyActiveCount
          capacitySkippedCount
          ineligibleSkippedCount
          copiedCount
          skippedCount
          gradebookMembershipAddedCount
          gradebookMembershipReactivatedCount
          gradebookMembershipAlreadyActiveCount
          gradebookMembershipCopiedCount
          unmatchedTranscriptCourseCount
          unmatchedGradebookMembershipCount
          finalActiveCount
          messages
        }
        userErrors { message path }
      }
    }
  `)
);

export { CopyClassRosterMutation };

interface CopyRosterCachePayload {
  userErrors?: ReadonlyArray<unknown> | null;
  targetResults?: ReadonlyArray<{ targetClassOfferingId: string }> | null;
}

export function evictCopiedRosterTargets(
  cache: Pick<ApolloCache<unknown>, 'identify' | 'evict'>,
  payload?: CopyRosterCachePayload | null,
) {
  if (!payload || payload.userErrors?.length) return;

  const targetIds = new Set(
    (payload.targetResults ?? []).map((target) => target.targetClassOfferingId)
  );
  targetIds.forEach((id) => {
    const cacheId = cache.identify({ __typename: 'ClassOffering', id });
    if (cacheId) cache.evict({ id: cacheId });
  });
}

export function useCopyClassRoster() {
  return useMutation(CopyClassRosterMutation, {
    update(cache, result) {
      evictCopiedRosterTargets(cache, result.data?.copyClassRoster);
    },
  });
}
